module.exports = __webpack_public_path__ + "static/media/app_store.a8ceb896.png";